import React from 'react';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  
  const handleClick = () => {
    const element = document.querySelector('#hakkimizda');
    if (element) {
      const navHeight = 64;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="relative h-screen w-full overflow-hidden" id="hero">
      {/* Background video with overlay */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="object-cover w-full h-full"
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          disableRemotePlayback
        >
          <source src="/videos/cover5.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Overlay with 70% brightness */}
        <div className="absolute inset-0 bg-black opacity-30"></div>
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 w-full items-center">
          {/* Left Column */}
          <div className="text-white space-y-4 md:space-y-6">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium">
              {t('hero.title')}
            </h1>
            <p className="text-base sm:text-lg md:text-xl font-regular max-w-lg">
              {t('hero.description')}
            </p>
            <button 
              onClick={handleClick}
              className="group relative overflow-hidden bg-primaryBlue hover:bg-primaryBlue text-white-900 rounded-full font-medium inline-flex items-center px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 text-sm sm:text-base"
            >
                            <span className="z-40">{t('hero.cta')}</span>
              <div className="z-40 ml-1.5 sm:ml-2 flex items-center justify-center">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-3 sm:h-3.5 md:h-4 w-3 sm:w-3.5 md:w-4 transition-all duration-300 group-hover:translate-x-1" 
                  viewBox="0 0 20 20" 
                  fill="currentColor"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" 
                    clipRule="evenodd" 
                  />
                </svg>
              </div>
              
            </button>
          </div>
          {/* Right Column - Empty for now */}
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection; 